import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { List } from 'linqts';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LocalStorage } from '../core/helper/localStorage';
import { BaseComponent } from '../core/component/Base.Component';
import { AppConstants } from '../app.constant';

@Component({
    templateUrl: 'userclients.component.html'
})
export class UserClientsComponent extends BaseComponent {

    model: any = {};
    userclients: any;
    localStorage: LocalStorage;
    seletedEntity;


    constructor() {
        super()

        if (this.localStorage !== undefined && this.localStorage.get('setseletedEntity'))
            this.localStorage.remove('setseletedEntity');

        if (!this.localStorage.get('token'))
            this.navigate('login');
    }

    async ngOnInit() {

        this.model.fullname = localStorage.getItem("Fullname").toUpperCase();
        this.model.username = localStorage.getItem("User").toUpperCase();
        this.model.clientstxt = localStorage.getItem("ClientStxt").toUpperCase();
        this.model.clientcode = localStorage.getItem("ClientCode").toUpperCase();
        this.model.userclients = localStorage.getItem("userclients");
        var userclients = JSON.parse(localStorage.getItem("userclients"));
        this.model.utuserclients = userclients;


        const clientids = this.getClientid();

    }

    getClientid(): any {

        var clientids = [];
        if (this.model !== null && this.model.utuserclients !== null) {
            for (let index = 0; index < this.model.utuserclients.length; index++) {
                const element = this.model.utuserclients[index].clientid;
                clientids.push(element);
            }
        }

        return clientids;
    }

    setseletedEntity(seletedEntity) {
        this.updateSchoolname(seletedEntity);

        if (this.localStorage.get('setseletedEntity'))
            this.localStorage.remove('setseletedEntity');

        this.localStorage.set('seletedEntity', seletedEntity);
    }

    async Checkclient() {

        if (this.localStorage.get('seletedEntity')) {
            this.navigate('home');
        }
        else
            this.navigate('login');
    }
    
    async updateSchoolname(entityid) {
        var data = this.LookupData.instituteList.filter(o => o.Id === entityid)[0];
        this.localStorage.set('ClientStxt', data.stxt);
    }

}



// WEBPACK FOOTER //
// ./src/app/userclients/userclients.component.ts